var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleRuler1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7565 21.7683L2.21336 12.5555C1.92888 12.2487 1.92888 11.7513 2.21336 11.4445L10.7565 2.23166C11.2154 1.73679 12 2.08727 12 2.78713V21.2129C12 21.9127 11.2154 22.2632 10.7565 21.7683ZM9.93976 17.5548L9.93965 6.44532L4.78879 12L9.93976 17.5548Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9384 22H15.0616C14.4753 22 14 21.5779 14 21.0572V20.75H17.5C17.9142 20.75 18.25 20.4142 18.25 20C18.25 19.5858 17.9142 19.25 17.5 19.25H14V16.75H16C16.4142 16.75 16.75 16.4142 16.75 16C16.75 15.5858 16.4142 15.25 16 15.25H14V12.75H17.5C17.9142 12.75 18.25 12.4142 18.25 12C18.25 11.5858 17.9142 11.25 17.5 11.25H14V8.75H16C16.4142 8.75 16.75 8.41421 16.75 8C16.75 7.58579 16.4142 7.25 16 7.25H14V4.75H17.5C17.9142 4.75 18.25 4.41421 18.25 4C18.25 3.58579 17.9142 3.25 17.5 3.25H14V2.94281C14 2.42211 14.4753 2 15.0616 2H20.9384C21.5247 2 22 2.42211 22 2.94281V21.0572C22 21.5779 21.5247 22 20.9384 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleRuler1);
export default __webpack_public_path__ + "static/media/triangle-ruler-1.f378602d40ee6070e04ff856d363e536.svg";
export { ForwardRef as ReactComponent };